import { UseAxiosResult } from "axios-hooks";
import apiConfig from "../infrastructure/http/apiConfig";
import { useAxiosGet } from "../infrastructure/http/axios";
import { apimName } from "./common";
import { initialAppDataResponse } from "./Models/types";

const initialAppDataUrl = `${apiConfig.apimUrl}${apimName}/InitialAppData`;

export function useGetInitialAppData(manual?: boolean): UseAxiosResult<initialAppDataResponse, any> {
	return useAxiosGet<initialAppDataResponse>(initialAppDataUrl, manual ?? false);
}
